import React from "react"
//import I18n from "i18n-js/index.js.erb"
import DataTable from "../../../DataTable/DataTable"

class NightAuditNoShowsDataTablePresenter extends React.Component {
  constructor(props) {
    super(props)
  };

  render() {
    // console.log('items and total', this.state.lodgingItems, this.state.lodgingTotal)
    return (
      <div className="panel panel-default">
        <div className="panel-body">
          <h3 className="panel-heading-text">{I18n.t('no_shows')}</h3>
          {/* <hr/> */}
          <div className="col-sm-12">
            <DataTable endpoint={this.props.night_audits_show_no_shows_path} date_format={this.props.date_format} time_format={this.props.time_format} delimiter={I18n.t('number.currency.format.delimiter')} separator={I18n.t('number.currency.format.separator')} export_csv_endpoint={this.props.export_no_show_csv_endpoint}/>
          </div>
        </div>
      </div>
    );
  };
};

export default NightAuditNoShowsDataTablePresenter